export const TIER_PRICES_RESET_STATE = 'TIER_PRICES_RESET_STATE';
export const TIER_PRICES_CURRENT_ITEM = 'TIER_PRICES_CURRENT_ITEM';

export const TIER_PRICES_REQUEST_LOADING = 'TIER_PRICES_REQUEST_LOADING';
export const TIER_PRICES_REQUEST_SUCCESS = 'TIER_PRICES_REQUEST_SUCCESS';
export const TIER_PRICES_REQUEST_FAILED = 'TIER_PRICES_REQUEST_FAILED';

export const TIER_PRICES_CURRENT_ACTION = 'TIER_PRICES_CURRENT_ACTION';
export const TIER_PRICES_RESET_ACTION = 'TIER_PRICES_RESET_ACTION';